<template>
  <app-modal
    name="adv-modal"
    click-to-close
    hide-header
    hide-footer
    :width="modalWidth"
  >
    <a href="https://pinvoice.vn/" target="_blank">
      <app-carousel :imgWidth="imgWidth" :imgHeight="imgHeight" :items="items"/>
    </a>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import AppCarousel from '@/components/app-carousel/';

export default {
  name: 'AdvModal',
  components: {
    AppModal,
    AppCarousel,
  },
  data() {
    return {
      items: [
        { img: '/images/banner-1.png' },
        { img: '/images/banner-2.png' },
        { img: '/images/banner-3.png' },
        { img: '/images/banner-4.jpg' },
        { img: '/images/banner-5.jpg' },
      ],
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    };
  },
  computed: {
    modalWidth() {
      return this.isMobile ? this.windowWidth : this.windowWidth * 0.6;
    },
    imgWidth() {
      return (this.isMobile ? this.modalWidth * 0.95 : this.modalWidth) - 32;
    },
    imgHeight() {
      return this.isMobile
        ? this.windowHeight * 0.3
        : this.windowHeight * 0.5;
    },
    isMobile() {
      return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      );
    },
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/adv-modal.vue